import { render, staticRenderFns } from "./FlexibleBenefitsListing.vue?vue&type=template&id=31efba4e&"
import script from "./FlexibleBenefitsListing.vue?vue&type=script&lang=js&"
export * from "./FlexibleBenefitsListing.vue?vue&type=script&lang=js&"
import style0 from "./FlexibleBenefitsListing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports